export default "__VITE_ASSET__BDN1S4Gq__"